import { useCallback, useEffect, useState } from "react";
import { useGoogleReCaptcha } from "react-google-recaptcha-v3";

import styles from './EstimateTime.module.css';
import BtnLoader from "../../assets/loaders/BtnLoader";

import { GetGeneralCitesService, GetStatesService, timeEstimationService } from "../../../services/registerApi";
import { showErrorMessage } from "../../../services/httpService";
import { errorMessage } from "../../../utils/message";

const EstimateTime = () => {
   const { executeRecaptcha } = useGoogleReCaptcha();

   const [loading, setLoading] = useState(false);
   const [states, setStates] = useState([]);
   const [originCities, setOriginCities] = useState([]);
   const [destCities, setDestCities] = useState([]);
   const [state, setState] = useState({ origin: '', destination: '' });
   const [city, setCity] = useState({ origin: '', destination: '' });
   const [estimatedTime, setEstimatedTime] = useState('');

   const handleReCaptchaVerify = useCallback(async () => {
      if (!executeRecaptcha) return;
      const token = await executeRecaptcha();
      return token;
   }, [executeRecaptcha]);

   useEffect(() => {
      const getStates = async () => {
         const res = await GetStatesService();
         if (res.error) {
            showErrorMessage(res);
         } else {
            setStates(res.data);
         }
      };
      getStates();
   }, []);

   const getCities = async (stateId) => {
      const res = await GetGeneralCitesService(stateId);
      if (res.error) {
         showErrorMessage(res);
         return [];
      } else {
         return res.data;
      }
   };
   const handleEstimate = async () => {
      if (!city.origin || !city.destination) return errorMessage('لطفا شهر مبدا و مقصد را مشخص نمایید');
      if (loading) return;

      setLoading(true);
      const token = await handleReCaptchaVerify();
      const res = await timeEstimationService(+city.origin, +city.destination, token);
      setLoading(false);

      if (res.error) {
         showErrorMessage(res);
      } else {
         setEstimatedTime(res.data);
      }
   };

   return (
      <>
         <main className="estimate" style={{ paddingBottom: 0 }}>
            <div className="estimate__title" style={{ marginBottom: '40px' }}>
               <h2 style={{ paddingBottom: '4px' }}>برآورد زمان</h2>
               <p>
                  در این قسمت شما می توانید بدون ثبت نام در سایت با توجه به مقادیر
                  خواسته شده زمان تقریبی ارسال کالا را استعلام بگیرید
               </p>
            </div>
            <div className={styles.container}>
               {/* مبدا  */}
               <div className={styles.fields_container} style={{ background: '#ddd' }}>
                  <label className="estimate__locataion-labels">
                     <p className={`${styles.estimate_title} estimate__locataion-title`}>مبدا</p>
                     <label className="estimate__locataion-label">
                        <p className="estimate__locataion-text">استان</p>
                        <select
                           className="estimate__locataion-select"
                           value={state?.origin ?? ''}
                           onChange={async (e) => {
                              setState(prev => ({ ...prev, origin: e.target.value }));
                              setOriginCities(await getCities(e.target.value));
                           }}
                        >
                           <option hidden>
                              انتخاب کنید ...
                           </option>
                           {states.map(item =>

                              <option key={item.stateId} value={item.stateId}>
                                 {item.name}
                              </option>
                           )}
                        </select>
                     </label>
                     <label className="estimate__locataion-label">
                        <p className="estimate__locataion-text">شهر</p>
                        <select
                           id="pet-select"
                           className="estimate__locataion-select"
                           value={city?.origin ?? ''}
                           onChange={(e) => setCity(prev => ({ ...prev, origin: e.target.value }))}
                        >
                           <option hidden>
                              انتخاب کنید ...
                           </option>
                           {originCities.map(item =>
                              <option key={item.id} value={item.id}>{item.name}</option>
                           )}
                        </select>
                     </label>
                  </label>
               </div>
               {/* مقصد  */}
               <div className={styles.fields_container} style={{ background: '#ddd' }}>
                  <label className="estimate__locataion-labels">
                     <p className={`${styles.estimate_title} estimate__locataion-title`}>مقصد</p>
                     <label className="estimate__locataion-label">
                        <p className="estimate__locataion-text">استان</p>
                        <select
                           className="estimate__locataion-select"
                           value={state?.destination ?? ''}
                           onChange={async (e) => {
                              setState(prev => ({ ...prev, destination: e.target.value }));
                              setDestCities(await getCities(e.target.value));
                           }}
                        >
                           <option hidden>انتخاب کنید ...</option>
                           {states.map(item =>
                              <option key={item.stateId} value={item.stateId}>
                                 {item.name}
                              </option>
                           )}
                        </select>
                     </label>

                     <label className="estimate__locataion-label">
                        <p className="estimate__locataion-text">شهر</p>
                        <select
                           className="estimate__locataion-select"
                           value={city?.destination ?? ''}
                           onChange={(e) => setCity(prev => ({ ...prev, destination: e.target.value }))}
                        >
                           <option hidden>انتخاب کنید ...</option>
                           {destCities.map(item =>
                              <option key={item.id} value={item.id}>{item.name}</option>
                           )}
                        </select>
                     </label>
                  </label>
               </div>
            </div>

            <button className={`${styles.estimate_btn} btn btn--secondary`} onClick={handleEstimate}>
               برآورد زمان
               {loading && <BtnLoader style={{ width: '16px', height: '16px' }} />}
            </button>
         </main>
         <div className={styles.result_container}>
            {estimatedTime &&
               <>
                  <p>زمان تقریبی:</p>
                  <span className={styles.result}>{estimatedTime}</span>
                  <span>ساعت</span>
               </>
            }
         </div>
      </>
   );
};

export default EstimateTime;